import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ScreensPreviewService } from '@app/services/screens-preview.service';

export const screensPreviewInterceptor: HttpInterceptorFn = (request, next) =>
    inject(ScreensPreviewService).respond(request) ?? next(request);
